import { Component, Input, OnInit } from '@angular/core';
import { AuthManagerService } from '../../api/auth/auth-manager.service';
import { BroadcastService } from '../../core/services/broadcast.service';

@Component({
	selector: 'mycampapp-section-loading-indicator',
	templateUrl: './section-loading-indicator.component.html',
	styleUrls: ['./section-loading-indicator.component.less']
})
export class SectionLoadingIndicatorComponent implements OnInit
{
	@Input() dataName = '';
	@Input() loading = false;
	@Input() requiresOrg = false;

	hasOrg = false;

	constructor(public authManager: AuthManagerService,
	            private broadcastService: BroadcastService) { }

	ngOnInit(): void
	{
		this.hasOrg = this.authManager.authenticatedUser?.organizationId != undefined;

		if (this.requiresOrg)
			this.broadcastService.userSignedIn.subscribe(() => this.hasOrg = this.authManager.authenticatedUser?.organizationId != undefined);
	}

}
